import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer } from "react-toastify";
import StaticFooter from "../common_components/StaticFooter";
import StaticHeader from "../common_components/staticHeader";
import $ from 'jquery'

class Press_release extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  componentDidMount() {
    this.loadscript()
  }
  loadscript() {
    $(document).ready(function () {
      $(this).scrollTop(0);
    });
  }

  render() {
    const { } = this.state;
    return (
      <>
        <StaticHeader />
        <>
          <div className="website">
            <section className="banner page-banner position-relative pb-0">
              <div className="overlay"></div>
              <div className="container">
                <div className="page-title text-center position-relative py-9">
                  <h2 className="text-white text-uppercase mt-4">
                    PR &amp; Media - Press Release
                  </h2>
                </div>
              </div>
            </section>
            <section className="news-archive" style={{ padding: "50px 0px" }}>
              <div className="container">
                <div className="news-archive-inner">
                  <div className="row gy-5">
                    <div className="col-lg-12">
                      <div className="news-left me-4 m-md-0">
                        <div className="row g-md-5 gy-5">
                          <div className="col-lg-4 col-md-4">
                            <div className="blog-box border border-1 rounded-2 pb-2 text-center">
                              <div className="blog-img">
                                <a href="static/pdf/Awards-Press-Release.pdf" target="blank">
                                  <img
                                    className="blog-img rounded-2 w-100 h-auto"
                                    src="static/images/press_release1.jpg"
                                    alt="blog-img"

                                  />
                                </a>
                              </div>
                              <div className="blog-info border-bottom p-4">
                                <h6 className="mb-2">
                                  <a
                                    href="static/pdf/Awards-Press-Release.pdf"
                                    className="black"
                                    target="blank"
                                  >
                                    India ITME Society opens up Nominations for its 2nd
                                    Edition of India ITME Society Awards 2022
                                  </a>
                                </h6>
                              </div>
                              <div className="pt-2 blog-data">
                                <a
                                  className="text-uppercase text-primary"
                                  href="static/pdf/Awards-Press-Release.pdf"
                                  target="blank"
                                >
                                  <small>Continue reading</small>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-4">
                            <div className="blog-box border border-1 rounded-2 pb-2 text-center">
                              <div className="blog-img">
                                <a href="static/pdf/Press-Release-India-ITME-Societys-40th-Year-Celebration.pdf" target="blank">
                                  <img
                                    className="blog-img rounded-top w-100 h-auto"
                                    src="static/images/press_release2.jpg"
                                    alt="blog-img"
                                  />
                                </a>
                              </div>
                              <div className="blog-info border-bottom p-4">
                                <h6 className="mb-2">
                                  <a
                                    href="static/pdf/Press-Release-India-ITME-Societys-40th-Year-Celebration.pdf"
                                    className="black"
                                    target="blank"
                                  >
                                    Facilitating Trade &amp; Cementing Friendships at
                                    India ITME Society’s 40th Year Celebration{" "}
                                  </a>
                                </h6>
                              </div>
                              <div className="pt-2 blog-data">
                                <a
                                  className="text-uppercase text-primary"
                                  href="static/pdf/Press-Release-India-ITME-Societys-40th-Year-Celebration.pdf"
                                  target="blank"
                                >
                                  <small>Continue reading</small>
                                </a>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-4 col-md-4">
                            <div className="blog-box border border-1 rounded-2 pb-2 text-center">
                              <div className="blog-img">
                                <a href="static/pdf/India-ITME-Awards-2nd-Edition-Press-Release.pdf" target="blank">
                                  <img
                                    className="blog-img rounded-top w-100 h-auto"
                                    src="static/images/2nd-Edition-Press-Release.jpg"
                                    alt="blog-img"
                                  />
                                </a>
                              </div>
                              <div className="blog-info border-bottom p-4">
                                <h6 className="mb-2">
                                  <a
                                    href="static/pdf/India-ITME-Awards-2nd-Edition-Press-Release.pdf"
                                    className="black text-center"
                                    target="blank"
                                  >
                                    India ITME Awards 2nd Edition Press Release {" "}
                                    
                                  </a>
                                  <p className="mb-1">&nbsp;</p>
                                </h6>
                              </div>
                              <div className="pt-2 blog-data">
                                <a
                                  className="text-uppercase text-primary"
                                  href="static/pdf/India-ITME-Awards-2nd-Edition-Press-Release.pdf"
                                  target="blank"
                                >
                                  <small>Continue reading</small>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <br />
          </div>
        </>

        <StaticFooter />
        <ToastContainer />
      </>
    )
  }
}
export default withRouter(
  connect(null, {})(Press_release)
);
